import { useState, useCallback, useRef } from "react";
import { notification } from "antd";
import { postBandeSortie } from "../../../../../../services/charroiService";

export function useBandeSortieSubmit({ onSuccess } = {}) {
  const [submitting, setSubmitting] = useState(false);

  // ✅ Bug #8 : Ref pour empêcher les doubles soumissions rapides (double-clic,
  // Entrée x2) même si le state React `submitting` n'est pas encore propagé au
  // bouton (disabled). Pareil que useAffectationSubmit.
  const inFlightRef = useRef(false);

  const submit = useCallback(async ({ payload }) => {
    if (inFlightRef.current) {
      console.warn("useBandeSortieSubmit: soumission déjà en cours, ignoré");
      return { ok: false, error: "Soumission déjà en cours", skipped: true };
    }

    inFlightRef.current = true;
    setSubmitting(true);

    try {
      const response = await postBandeSortie(payload);

      notification.success({
        message: "Succès",
        description: "Le bon de sortie a été enregistré avec succès.",
      });

      onSuccess?.();

      return {
        ok: true,
        id: response.data?.id_bande_sortie,
       };
    } catch (error) {
      console.error("useBandeSortieSubmit.submit", error);

      const status = error?.response?.status;
      const serverMessage = error?.response?.data?.error;

      if (status === 409 && serverMessage) {
        notification.warning({
          message: "Création impossible",
          description: serverMessage,
          duration: 6,
        });
      } else {
        notification.error({
          message: "Erreur",
          description: serverMessage || "Échec de l'opération.",
        });
      }

      return { ok: false, error };
    } finally {
      inFlightRef.current = false;
      setSubmitting(false);
    }
  }, [onSuccess]);

  return { submitting, submit };
}
